import { RecordInfo } from './Clients/RecordInfo';
import { RecordInfoData } from 'types/RecordInfoData';

export const RecordInfoRepository = {
  getRecordInfo(courseId: string): Promise<RecordInfoData> {
    return RecordInfo.get(`?roomId=${courseId}`).then((res) => res.data);
  },
};
